import { STATUS_SUBMITTED, STATUS_UPDATED } from './ApprovalRequestConstants'

export const SSD_MATERIALS_FIELDS = {
  'fontSize'                      : { name: 'fontSize' }, // Used for referencing the property name, is not an actual field
  '14point'                       : { name: 'fontSize', value: 1 },
  '20point'                       : { name: 'fontSize', value: 3 },
  'customFontSize'                : { name: 'fontSize', value: 2 },
  'customFontSizeNumber'          : { name: 'customFontSize', value: '' },
  'braille'                       : { name: 'fontSize', value: 4 },
  'assistiveTechnologyCompatible' : { name: 'fontSize', value: 13 },
  'largeBlockAnswerSheet'         : { name: 'largeBlockAnswerSheet', value: 5 },
  'readerCopy'                    : { name: 'readerCopy', value: 6 },
  'printedScript'                 : { name: 'printedScript', value: 7 },
  'multipleDayTesting'            : { name: 'multipleDayTesting', value: 8 },
  'limitedTimeTesting'            : { name: 'limitedTimeTesting', value: 9 },
  'otherAccommodations'           : { name: 'otherAccommodations', value: 11 },
  'ssdMaterialsNotOrdered'        : { name: 'ssdMaterialsNotOrdered', value: 12 }
}

export const SSD_MATERIALS_STYLE_MAP = {
  [STATUS_SUBMITTED] : { fontStyle: 'normal' },
  [STATUS_UPDATED]   : { fontStyle: 'normal' }
}

export const EXCEPTION_TESTING_EXAM_STARTED = 'examStarted'
export const EXCEPTION_TESTING_EXAM_NOT_STARTED = 'examNotStarted'
export const EXCEPTION_TESTING_STATUS = {
  [EXCEPTION_TESTING_EXAM_STARTED]: 'Student Started Exam',
  [EXCEPTION_TESTING_EXAM_NOT_STARTED]: 'Student Did Not Start Exam'
}
